import { Link, LinkProps, To } from "react-router-dom";

import { useRoutePathPrefix } from "../hooks/use-route-path-prefix";

/**
 * Drop-in replacement for React Router's `Navigate` that prefixes the path with the given path prefix.
 */
export function RouteLink({ to: toProp, ...restProps }: LinkProps) {
  const routingPathPrefix = useRoutePathPrefix();

  const to = ((): To => {
    if (typeof toProp === "string") {
      return `${routingPathPrefix}${toProp}`;
    }

    return {
      ...toProp,
      pathname: `${routingPathPrefix}${toProp.pathname}`,
    };
  })();

  return <Link to={to} {...restProps} />;
}
